import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useEffect, useState} from 'react';

import {AliasData} from 'molbio/monomers/MonomersDAO';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

const EDITOR_HEIGHT = 300;
const EDITOR_WIDTH = 400;

export function aliasToCSV(alias: AliasData): string {
  return [alias.token, alias.helmToken, alias.tokenVariantStart, alias.tokenVariantEnd]
    .filter((value) => Boolean(value))
    .join(',');
}

interface AliasCreationFormProps {
  onSubmit: (formText: string) => Promise<Array<AliasData>>;
  updateLocalState: (newAliases: Array<AliasData>) => void;
  syntaxName: string;
}
export default function AliasCreationForm({
  onSubmit,
  updateLocalState,
  syntaxName,
}: AliasCreationFormProps): JSX.Element {
  const [formText, setFormText] = useState<string>('');

  useEffect(() => {
    setFormText('');
  }, [syntaxName]);

  return (
    <div className={classNames('u-flex-display', 'u-vertical-flex', 'u-spacing-right')}>
      <textarea
        className={css(styles.textArea)}
        cols={20}
        rows={20}
        placeholder={`${syntaxName} token, HELM token, ${syntaxName} 5' variant (optional), ${syntaxName} 3' variant (optional)`}
        value={formText}
        onChange={(e) => {
          setFormText(e.target.value);
        }}
      />
      <Button
        className={css(styles.verticalButton)}
        buttonStyle={ButtonStyle.PRIMARY}
        size={ButtonSize.SMALL}
        text={`Create ${syntaxName} aliases`}
        onClick={async () => {
          const newAliases = await onSubmit(formText);
          updateLocalState(newAliases);
          setFormText('');
        }}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  verticalButton: {
    marginTop: '20px',
  },
  textArea: {
    height: `${EDITOR_HEIGHT}px`,
    width: `${EDITOR_WIDTH}px`,
  },
});
